import QueryString from "qs"
import http from "../index"
import {
    apiListSupplier,
    apiCreateSuplier,
    apiUpdateSuplier,
    apiDeleteSupplier,
    apiListContractSupplier,
    apiCreateContractSupplier
} from "./urls"

const ListSupplier = params => http.get(apiListSupplier, { params })
const CreateSuplier = body => http.post(apiCreateSuplier, body)
const UpdateSupplier = (params, id) => http.put(`/1.0/wsm/supplier/${id}/update`, params);
const DeleteSupplier = (params)=> http.delete(apiDeleteSupplier, { params });
const detailSupplier = (id) => http.get(`/1.0/wsm/supplier/${id}/detail`);
const ListContractSupplier = params => http.get(apiListContractSupplier, { params })
const createContractSupplier = body => http.post(apiCreateContractSupplier, body)
const updateContractSupplier = (id, body) => http.post(`/1.0/wsm/contract/supplier/${id}/update`, body);
const detailContractSupplier = (id) => http.get(`/1.0/wsm/contract/supplier/${id}/detail`);
const updateStatusBrowse = (id, body) => http.put(`1.0/wsm/contract/supplier/${id}/browse`, body)
const updateStatusRefuse = (id, body) => http.put(`1.0/wsm/contract/supplier/${id}/refuse`, body)
const updateStatusSigned = (id, body) => http.put(`1.0/wsm/contract/supplier/${id}/signed`, body)

const SupplierManager = {
    ListSupplier,
    CreateSuplier,
    UpdateSupplier,
    DeleteSupplier,
    ListContractSupplier,
    detailSupplier,
    createContractSupplier,
    updateContractSupplier,
    detailContractSupplier,
    updateStatusBrowse,
    updateStatusRefuse,
    updateStatusSigned
}
export default SupplierManager